//angular imports
import { Signal, computed } from "@angular/core";

//local imports
import { Func } from "@app/shared";

export class SignalWrapper<TRootType, TSignalType extends Signal<TRootType>>
{    
    public coreSignal: TSignalType;
    public overrideSignal: Signal<TRootType>;

    public static create<TRootType, TSignalType extends Signal<TRootType>>(request: {
        coreSignal: TSignalType, 
        overrideSignalFn: Func<TSignalType, Signal<TRootType>>
    })
    {
        let _this = new SignalWrapper<TRootType, TSignalType>();
        
        _this.coreSignal = request.coreSignal;
        _this.overrideSignal = request.overrideSignalFn(request.coreSignal);

        return _this;
    }
}